export default {
	title: 'Máté Borkesz - Portfolio 💾',
	ogTitle: 'Máté Borkesz - Portfolio 💾',

	description: 'Máté Borkesz - Portfolio 💾',
	ogDescription: 'Máté Borkesz - Portfolio 💾',

	ogImage: 'https://borkeszmate.hu/assets/bm_2022@2x.6b5cf0b0.jpg',
};
